import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import { api } from '@/api/client'
import { TimeSeriesChart } from '@/components/charts/TimeSeriesChart'
import { Card, ErrorText } from '@/components/ui'

import type { Stat, StatKey } from './api'

type Snapshot = {
  day: string
  level: number
  xp: number
  special: Stat[]
}

export function CharacterHistoryCard() {
  const [metric, setMetric] = useState<'level' | StatKey>('level')
  const query = useQuery({
    queryKey: ['character', 'history'],
    queryFn: () => api.get<Snapshot[]>('/character/history'),
    staleTime: 60_000,
  })
  const points = Array.isArray(query.data) ? query.data : []
  const stats = points.at(-1)?.special ?? []
  const label = stats.find((stat) => stat.key === metric)?.name ?? 'Уровень'
  return (
    <Card title="История персонажа" className="mt-4"
      subtitle="За 12 месяцев. Для текущего месяца показано значение на сегодня.">
      {query.isPending ? <p className="text-sm text-muted">Загружаем историю…</p> : query.error ? (
        <ErrorText error={query.error}>Не удалось загрузить историю персонажа.</ErrorText>
      ) : points.length ? (
        <>
          <label className="mb-3 flex flex-wrap items-center gap-2 text-sm">
            Показатель
            <select className="min-h-10 rounded-lg border border-border bg-surface px-2"
              value={metric} onChange={(event) => setMetric(event.target.value as 'level' | StatKey)}>
              <option value="level">Уровень</option>
              {stats.map((stat) => <option key={stat.key} value={stat.key}>{stat.key} · {stat.name}</option>)}
            </select>
          </label>
          <TimeSeriesChart period="all" showPeriods={false} height={220}
            emptyText="Для этого показателя пока нет данных."
            series={[{
              key: metric,
              label,
              digits: metric === 'level' ? 0 : 1,
              points: points.map((point) => ({
                x: point.day,
                y: metric === 'level' ? point.level : point.special.find((stat) => stat.key === metric)?.value ?? null,
              })),
            }]}
          />
        </>
      ) : <p className="text-sm text-muted">История пока недоступна.</p>}
    </Card>
  )
}
